import moment from 'moment';

export default (rule, date) => {
  if (date && moment(date, 'DD/MM/YYYY', true).isValid()) {
    return moment(date, 'DD/MM/YYYY').isBefore(moment());
  }

  return true;
};
